import { render, staticRenderFns } from "./SolicitudBeneficios.vue?vue&type=template&id=08428def&scoped=true"
import script from "./SolicitudBeneficios.vue?vue&type=script&lang=js"
export * from "./SolicitudBeneficios.vue?vue&type=script&lang=js"
import style0 from "./SolicitudBeneficios.vue?vue&type=style&index=0&id=08428def&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08428def",
  null
  
)

export default component.exports